import jwt_decode from "jwt-decode";

export function decode(token) {
    const jwt = jwt_decode(token);
    return JSON.stringify(jwt);
}

